import type { CSS } from '@grupoboticario/flora-react'

export const headerRowCss: CSS = {
  marginBottom: '$6',
  flexDirection: 'column',
  gap: '$4',
  '@desktop': {
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
}
